import React, { useState } from "react";
import Box from "@mui/material/Box";
import NavNotLoggedIn from "../components/NavNotLoggedIn";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@material-ui/core";
import { MdError } from "react-icons/md";

const useStyles = makeStyles({
  display: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  field: {
    width: 360,
    ["& fieldset"]: {
      borderRadius: 10,
    },
  },
});

function SignUp() {
  const classes = useStyles();
  const [openFailed, setOpenFailed] = useState(false);
  const handleSignup = () => {
    setOpenFailed(true);
  };

  return (
    <div>
      <NavNotLoggedIn />
      <Box>
        <Grid container>
          {/* Box incluant l'image */}
          <Grid
            item
            sm={6}
            sx={{
              display: { xs: "none", sm: "block" },
            }}
          >
            <Box className="boxImageLogIn">
              <Box
                mr={15}
                component="img"
                alt="Component"
                src="/Component_205_1.png"
              />
            </Box>
          </Grid>

          {/* Box generale du SignUp */}
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              alignItems: "center",
              // justifyContent: "center",
            }}
          >
            <Box className="boxSignUp">
              <Typography
                component="div"
                gutterBottom
                sx={{ fontWeight: "bold", fontSize: 30 }}
              >
                Bienvenue chez Carlo
              </Typography>
              <Typography
                component="div"
                gutterBottom
                sx={{ fontWeight: "bold", fontSize: 16 }}
              >
                Inscription avec L'Email
              </Typography>

              <TextField
                className={classes.field}
                label="Nom du commerce"
                margin="normal"
              />
              <TextField
                className={classes.field}
                label="Email"
                margin="normal"
              />
              <TextField
                className={classes.field}
                label="Confirmation de l'email"
                margin="normal"
              />
              <TextField
                className={classes.field}
                label="Mot de passe"
                margin="normal"
              />
              <Box mb={2} />
              <Button
                onClick={() => handleSignup()}
                variant="contained"
                size="large"
              >
                S'inscrire
              </Button>

              <Modal open={openFailed}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "#fff",
                    p: 4,
                    borderRadius: 5,
                  }}
                >
                  <IconButton color="error" className={classes.icon}>
                    <MdError className={classes.icon} />
                  </IconButton>
                  <Typography mb={2}>
                    Nous avons recontré une erreur, veuillez réessayer ou nous
                    contacter
                  </Typography>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setOpenFailed(false)}
                  >
                    Fermer
                  </Button>
                </Box>
              </Modal>

              <Box
                mt={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography variant="body1" gutterBottom>
                  Vous avez déjà un compte ?
                </Typography>
                <Box ml={1} />
                <Link href="/" underline="always">
                  {" Se connecter"}
                </Link>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default SignUp;
